/** Page forms (16 October 2026): the funnel's config and the one-step submission. */
import type { FormSubmitRequest, FormSubmitResponse, WidgetConfigResponse } from "@wapadesk/schema";
import { ApiClientError } from "./api";
import { BookApi } from "./book-api";

export class FormApi extends BookApi {
  /** A share link carries the slug, an embed the clinic id; like the booking page, try the slug first. */
  async config(ref: string, formId: string, page: string): Promise<WidgetConfigResponse> {
    const rest = `&form=${encodeURIComponent(formId)}&page=${encodeURIComponent(page)}`;
    if (/^[a-z0-9-]{2,64}$/.test(ref)) {
      try {
        return await this.call("GET", `/v1/widget/config?slug=${encodeURIComponent(ref)}${rest}`);
      } catch (e) {
        if (!(e instanceof ApiClientError) || e.status !== 404) throw e;
      }
    }
    return this.call("GET", `/v1/widget/config?clinic=${encodeURIComponent(ref)}${rest}`);
  }
  async submit(body: FormSubmitRequest): Promise<FormSubmitResponse> {
    const r = await this.call<FormSubmitResponse>("POST", "/v1/widget/form-submit", body);
    this.token = r.sessionToken;
    return r;
  }
}
